// extracted by mini-css-extract-plugin
module.exports = {"roundedLink":"styles_roundedLink__1XNzP","footer":"styles_footer__2jx7K"};